import { profileSlice } from 'redux/slices/profile-slice';

export const { changeMobileMenu } = profileSlice.actions;
